import React, { useState } from 'react';
import {
  HomeOutlined,
  UserOutlined,
  NotificationOutlined,
  BarChartOutlined,
  HistoryOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Tabs } from 'antd';
import PageHeader from '../../utility/PageHeader';
import HomeTab from './HomeTab';
import CustomerTab from './Customer/CustomerTab';
import PushManage from './Push/PushManage';
import StatTab from './StatTab';
import LogTab from './LogTab/LogTab';
import OrderManagement from './OrderManagement';
import ChargingMoneyManagement from './ChargingMoneyManagement';

const Charging = () => {
  // 充電管理頁面內容
  const ChargingManagementContent = () => {
    const [activeTab, setActiveTab] = useState('order-management');

    const managementTabs = [
      {
        key: 'order-management',
        label: '訂單列表',
        component: <OrderManagement />,
      },
      {
        key: 'coupon-charging-list',
        label: '優惠券/充電金列表',
        component: <ChargingMoneyManagement />,
      },
    ];

    return (
      <div
        style={{
          background: '#f7faf9',
          padding: 24,
          borderRadius: 16,
          marginTop: 24,
        }}>
        {/* 自定義選項卡按鈕 */}
        <div
          style={{
            display: 'flex',
            width: '100%',
            marginBottom: 16,
            borderBottom: '1px solid #f0f0f0',
          }}>
          {managementTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                flex: 1,
                padding: '12px 16px',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                borderBottom:
                  activeTab === tab.key
                    ? '2px solid #1890ff'
                    : '2px solid transparent',
                color: activeTab === tab.key ? '#1890ff' : '#666',
                fontWeight: activeTab === tab.key ? 'bold' : 'normal',
                fontSize: '16px',
                textAlign: 'center',
              }}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* 內容區域 */}
        <div>
          {managementTabs.find((tab) => tab.key === activeTab)?.component}
        </div>
      </div>
    );
  };

  const tabItems = [
    {
      key: 'home',
      label: (
        <span>
          <HomeOutlined style={{ marginRight: 8 }} />
          首頁
        </span>
      ),
      content: <HomeTab />,
    },
    {
      key: 'charging-management',
      label: (
        <span>
          <SettingOutlined style={{ marginRight: 8 }} />
          充電紀錄
        </span>
      ),
      content: <ChargingManagementContent />,
    },
    {
      key: 'stat',
      label: (
        <span>
          <BarChartOutlined style={{ marginRight: 8 }} />
          統計分析
        </span>
      ),
      content: <StatTab />,
    },
    {
      key: 'customer',
      label: (
        <span>
          <UserOutlined style={{ marginRight: 8 }} />
          用戶管理
        </span>
      ),
      content: <CustomerTab />,
    },
    {
      key: 'push',
      label: (
        <span>
          <NotificationOutlined style={{ marginRight: 8 }} />
          推播平台
        </span>
      ),
      content: <PushManage />,
    },
    {
      key: 'log',
      label: (
        <span>
          <HistoryOutlined style={{ marginRight: 8 }} />
          後台歷程
        </span>
      ),
      content: <LogTab />,
    },
  ];

  return (
    <div>
      <PageHeader functionName={'charging'} />
      <div
        className="main-container"
        style={{ background: 'none', boxShadow: 'none', padding: 0 }}>
        <div className="charging-content">
          <Tabs
            className="charging-tabs"
            defaultActiveKey="home"
            items={tabItems.map((tab) => ({
              key: tab.key,
              label: tab.label,
              children: tab.content,
            }))}
          />
        </div>
      </div>
    </div>
  );
};

export default Charging;
